// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__j4aKc"};